export default __webpack_public_path__ + "static/media/logo-dark.cf1fcd97af5268ee1063ce7054b6d2bd.png";